import { render } from "./lead-source-chart.vue?vue&type=template&id=28a20c38"
import script from "./lead-source-chart.vue?vue&type=script&lang=js"
export * from "./lead-source-chart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__